export const styles = {
  memberConatiner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '4px 0',
    gap: '12px',
    height: '60px',
  },
  userAvatar: {
    width: '36px',
    height: '36px',
    borderRadius: '4px',
    border: '2px solid #FFFFFF',
  },
  userName: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '146%',
    color: '#23252F',
  },
  defaultAvatar: {
    borderRadius: '4px',
    width: '36px',
    height: '36px',
  },
};
